import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as InteractiveIcon } from "../../../assets/svg/interactive-help-icon-blue.svg";

const InteractiveHelp = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                interactive_help: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    }, []);
    // const configureProgress = () => {
    //     dispatch(configure_progress("explore_search"));
    // };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        <InteractiveIcon className="icon_content" />
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <span className="content_title">Interactive help</span>
                    </div>

                    <div className="text_content">
                        <p>{`Interactive help gives you contextual help for different sections in the page.`}</p>
                        <p>{`If you are stuck somewhere and do not know how to use a specific feature or functionality, this help can be of great use.  Get step-by-step help and videos on various features on the page you are in right now.`}</p>
                        <p>{`When you are done, you can switch off the interactive help by toggling the on/off button.`}</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    {/* <Link to="/profile">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link> */}
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/1i8AlDKao_0"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default InteractiveHelp;
